export default "__VITE_ASSET__BYbiQUQn__"